module.exports = __webpack_public_path__ + "img/wechat.fc3bb5e0.jpg";